import { render } from "./house.vue?vue&type=template&id=29991b10"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"

import "./house.vue?vue&type=style&index=0&id=29991b10&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-house/layout6/house.vue'],['render',render],['__file',"house.vue"]])

export default __exports__